<template>
  <div>
    <slot name="css">
      <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,600,700">
      <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons">
    </slot>
    <template v-if="$store.getters['isOpen'] === true">
      <slot name="button">
        <div :class="$store.getters['step'] === 'chatbox' ? 'gb-zb-button gb-zb-open' : 'gb-zb-button gb-zb-closed' "
             v-if="['button', 'chatbox'].indexOf($store.getters['step']) > -1 "
             v-on:click="toggle">
        </div>
      </slot>

      <div class="gb-zb-widget-wrapper gb-zb-open"
           v-if="$store.getters['step'] === 'chatbox' "
           :data-gb-account="$settings.account">
        <div class="gb-zb-widget-header">
          <div>
            <slot name="header">
              <strong>Bonjour !</strong>
              <div class="gb-zb-widget-opacity">
                Démarrer une conversation
              </div>
            </slot>
          </div>
          <div class="gb-zb-reset" v-on:click="reset()">
            <i class="material-icons large">home</i>
          </div>
        </div>
        <span class="gb-zb-widget-close"></span>
        <div class="gb-zb-widget">
          <div v-for="(msg, index) in $store.getters['messages']"
               :key="index" >
            <div v-for="(rich_content, jndex) in msg.rich_content"
                 v-bind:key="jndex">
              <!-- {{ rich_content.kind }} -->
              <template v-if="rich_content.kind === 'txt' ">
                <content-txt :content=rich_content />
              </template>
              <template v-else-if="rich_content.kind === 'choice' ">
                <content-choice :content=rich_content />
              </template>
              <template v-else-if="rich_content.kind === 'choosed' ">
                <content-choosed :content=rich_content />
              </template>
              <template v-if="rich_content.kind === 'file' ">
                <content-file :content=rich_content />
              </template>
              <template v-else-if="rich_content.kind === 'location' ">
                <content-location :content=rich_content :index=jndex />
              </template>
              <template v-else-if="rich_content.kind === 'payment' ">
                <payment :content=rich_content />
              </template>
              <template v-else-if="rich_content.kind === 'payment_result' ">
                <payment-succeeded :content=rich_content />
              </template>
              <template v-else-if="rich_content.kind === 'satisfaction' ">
                <survey-choice :content=rich_content />
              </template>
              <template v-else-if="rich_content.kind === 'timeslot_choice' ">
                <timeslot-choice :content=rich_content />
              </template>
              <template v-else-if="rich_content.kind === 'timeslots' ">
                <timeslots :content=rich_content />
              </template>
              <template v-else-if="rich_content.kind === 'url' ">
                <content-url :content=rich_content :target="_blank" />
              </template>
            </div>
          </div>
          <loader v-if="$store.getters['isLoaderSeen'] === true" />
        </div>
        <div class="gb-zb-form">
          <upload :url=url :acceptedFileTypes=acceptedFileTypes
                  :maxFileSize=maxFileSize
                  :postUploadHandler=postUploadHandler
                  v-if="$store.getters['isUpload']">
          </upload>
          <form v-on:submit.prevent="submitForm"
                v-if="!$store.getters['isUpload']">
            <input :type="$store.getters['inputType']" name="message"
                   :placeholder="$t('form.placeholder')"
                   v-model="userMsg"
                   :disabled="!$store.getters['canType']"
                   autocomplete="off">
            <button name="send" class="gb-zb-send">
              <i class="material-icons">send</i>
            </button>

          </form>
          <button name="upload" class="gb-zb-upload" v-on:click="toggleUpload()">
            <i class="material-icons">note_add</i>
          </button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import 'dayjs/locale/fr' // load on demand
import pageTitleNotification from '@/components/flash-title'

import GuestCookie from '@/components/guest-cookie'
import Loader from '@/components/Loader.vue'
import Upload from '@/components/Upload.vue'
import ContentChoice from '@/layout/messages/ContentChoice.vue'
import ContentChoosed from '@/layout/messages/ContentChoosed.vue'
import ContentFile from '@/layout/messages/ContentFile.vue'
import ContentLocation from '@/layout/messages/ContentLocation.vue'
import ContentTxt from '@/layout/messages/ContentTxt.vue'
import ContentUrl from '@/layout/messages/ContentUrl.vue'
import SurveyChoice from '@/layout/messages/SurveyChoice.vue'
import TimeslotChoice from '@/layout/messages/TimeslotChoice.vue'
import Timeslots from '@/layout/messages/Timeslots.vue'

dayjs.extend(LocalizedFormat)
dayjs.locale('fr') // use French locale globally

const flashTitle = pageTitleNotification()

export default {
  name: 'Widget',
  components: {
    ContentChoice,
    ContentChoosed,
    ContentFile,
    ContentLocation,
    ContentTxt,
    ContentUrl,
    Loader,
    SurveyChoice,
    TimeslotChoice,
    Timeslots,
    Upload
  },
  computed: {
    acceptedFileTypes () {
      return 'image/gif, image/jpeg, image/png, application/octet-stream, ' +
        'application/pdf, application/gzip, application/x-gzip, text/plain'
    },
    caller: {
      get () {
        return this.$store.getters.caller
      },
      set (value) {
        return this.$store.commit('updateCaller', value)
      }
    },
    isLoaderSeen () {
      return this.$store.getters.isLoaderSeen
    },
    maxFileSize () {
      return 5242880
    },
    messagesCount () {
      return this.$store.getters.messages.length
    },
    url () {
      const uploadUrl = process.env.VUE_APP_UPLOAD_URL
      return uploadUrl
    },
    userMsg: {
      get () {
        return this.$store.getters.userMsg
      },
      set (value) {
        return this.$store.commit('updateUserMsg', value)
      }
    }
  },
  methods: {
    addEmoji (emoji) {
      this.userMsg += emoji.data
      this.$store.commit('updateEmojiPickerShown', false)
    },
    postUploadHandler (params, fileData) {
      let filename = params.file.substr(params.file.lastIndexOf('/') + 1)
      fileData.forEach((item) => {
        if (item.name !== undefined) {
          filename = item.name
        }
      })
      this.$store.dispatch({
        type: 'sendMsg',
        settings: this.$settings,
        content: params.file,
        richContent: {
          kind: 'url',
          url: params.file,
          txt: filename
        }
      })
      this.toggleUpload()
    },
    reset () {
      this.$store.dispatch({
        type: 'sendMsg',
        settings: this.$settings,
        content: 'reset',
        richContent: 'reset'
      })
    },
    scroll () {
      const that = this
      const widget = document.querySelector(
        `.gb-zb-widget-wrapper[data-gb-account='${this.$settings.account}'] .gb-zb-widget`)
      window.setTimeout(function () {
        if (widget) {
          if (widget.scrollHeight > widget.clientHeight) {
            let delta = 0
            if (that.$store.getters.isLoaderSeen === true) {
              delta = 50
            }
            widget.scrollTop = widget.scrollHeight + delta
          }
        }
      }, 250)
    },
    submitForm () {
      if (this.userMsg !== '') {
        this.$store.dispatch({
          type: 'sendMsg',
          settings: this.$settings,
          content: this.userMsg,
          richContent: this.userMsg
        })
        this.userMsg = ''
      }
    },
    toggle () {
      const step = this.$store.getters.step === 'button' ? 'chatbox' : 'button'
      if (step === 'button') {
        GuestCookie.storeGuest('close', this.$store.getters.account, 'on')
      }
      this.$store.dispatch({
        type: 'changeStep',
        step: step
      })
      this.$store.dispatch({
        type: 'initWebsocket'
      })
    },
    toggleEmojiPicker () {
      this.$store.commit('updateEmojiPickerShown')
    },
    toggleUpload () {
      this.$store.commit('toggleUpload')
    }
  },
  watch: {
    caller (newValue) {
      this.$store.commit('updateErrors', {})
      const pattern = '^(([0-9]{10})|(\\s|[0-9]{2}){8}([0-9]{2})|(-|[0-9]{2}){8}([0-9]{2}))$'
      const re = new RegExp(pattern)
      const test = re.test(newValue)
      if (!test) {
        this.$store.commit('updateErrors', {
          caller: ['Votre numéro doit comporter 10 chiffres et commencer par 0']
        })
      }
    },
    isLoaderSeen (newValue) {
      if (newValue === true) {
        this.scroll()
      }
    },
    messagesCount (newValue) {
      this.scroll()
    }
  },
  created () {
    this.$store.dispatch({
      type: 'changeStep',
      step: 'button'
    })
    window.addEventListener('blur', () => {
      this.$store.commit('updateIsAllowedToPush', true)
    })
    window.addEventListener('focus', () => {
      this.$store.commit('updateIsAllowedToPush', false)
      flashTitle.off()
    })
  }
}
</script>

<style lang="scss" scoped>
@import '@/components/widget.scss';
</style>
